import React, { useCallback, useEffect, useState } from 'react';
import { fabric } from 'fabric';
import Slider from 'rc-slider';
import 'rc-slider/assets/index.css';
import { SketchPicker } from 'react-color';


const TextTool = ({canvas, className})=>{

    const [state, setState] = useState({
                displayTextColorPicker:false,
                activeText:false,
                textbox:null,
                fontSize:20,
                lineHeight:1.16,
                charSpacing:0,
                textColor:'#fff',
                textAlign:"center"
            });

    const onSelectionUpdated = useCallback(
        (event)=>{
            if(event.selected[0].isType('textbox')){
                const textbox = event.selected[0];
                setState({...state, activeText:true,
                    displayTextColorPicker:false,
                    textbox:textbox,
                    fontSize:textbox.fontSize,
                    lineHeight:textbox.lineHeight,
                    charSpacing:textbox.charSpacing,
                    textAlign:textbox.textAlign});
            }else{
                setState({...state, activeText:false, displayTextColorPicker:false});
            }
        },
        [state],
    );

    const onSelectionCleared = useCallback(
        (event)=>{
            setState({...state, activeText:false, textbox:null });
        },
        [state],
    );
    
    useEffect(() => {
        canvas.on('selection:created', onSelectionUpdated);
        canvas.on('selection:updated', onSelectionUpdated);
        canvas.on('selection:cleared', onSelectionCleared);
        return () => {
            canvas.off('selection:created', onSelectionUpdated);
            canvas.off('selection:updated', onSelectionUpdated);
            canvas.off('selection:cleared', onSelectionCleared);
        }
    }, [canvas, onSelectionUpdated, onSelectionCleared]);


    // 글상자 추가
    function appendText(event){
        let text = new fabric.Textbox('글자를 클릭하여 글을 쓰세요.', { 
            width:300,
            fontSize:state.fontSize,
            fontFamily: 'Nanum Gothic', 
            textAlign:state.textAlign,
        });
        // text.center();
        
        text.left = canvas.width*0.5 - text.width*0.5;
        text.top = canvas.height*0.5 - text.height*0.5;
        canvas.add(text);
        canvas.setActiveObject(text);
    }

    //삭제
    function removeText(){
        canvas.remove(state.textbox);
    }

    //폰트 크기
    function onChangeFontSize(value){
        if( null!==state.textbox ){
            state.textbox.set("fontSize", value);
            setState({...state, fontSize:value});
            canvas.renderAll();
        }
    }

    // 글자 간격
    function onChangeSpacing(value){
        if( null!==state.textbox ){
            state.textbox.set("charSpacing", value);
            setState({...state, charSpacing:value});
            canvas.renderAll();
        }
    }

    //줄 간격
    function onChangeLineHeight(value){
        if( null!==state.textbox ){
            setState({...state, lineHeight:value});
            state.textbox.set("lineHeight", value);
            canvas.renderAll();
        }
    }

    function onChangeTextColor(color){
        setState({...state, textColor:color.hex});
        state.textbox.set("fill", color.hex);
        canvas.renderAll();
    }

    //폰트 정렬
    function onChangeTextAlign(event) {
        const value = event.currentTarget.value;
        state.textbox.set("textAlign", value);
        setState({...state, textAlign:value});
        canvas.renderAll();
    }
    
    return (
        <div className="textboxContainer">
            <div className="controls text-center">
                <button className="btn _xsm _blue " onClick={appendText}>글상자 추가</button>
                {state.activeText && <button className="btn _xsm _red" onClick={removeText}>글상자 삭제</button>}
            </div>
            { state.activeText &&
                <div className="options">
                    <div className="option fontSize">
                        <div className="label">글 크기 <span className="value">{state.fontSize}</span></div>
                        <Slider min={5} max={200} value={state.fontSize} onChange={onChangeFontSize}  tipFormatter={value=>`${value}$`} />
                    </div>
                    <div className="option spacing">
                        <div className="label">글자 간격 <span className="value">{state.charSpacing}</span></div>
                        <Slider min={0} max={3000} value={state.charSpacing} onChange={onChangeSpacing}  tipFormatter={value=>`${value}$`} />
                    </div>
                    <div className="option">
                        <div className="label">줄 간격 <span className="value">{state.lineHeight}</span></div>
                        <Slider min={0} max={5.01} step={0.01} value={state.lineHeight} onChange={onChangeLineHeight} />
                    </div>

                    <div className="option colorPicker">
                        <div className="label">글자 색</div>
                        <div className="swatch" onClick={()=>{setState({...state, displayTextColorPicker:!state.displayTextColorPicker})}}>
                            <div className="color" style={ {background:`${state.textColor}`}} />
                        </div>
                        { state.displayTextColorPicker &&
                            <div className="popover">
                                <div className="cover" onClick={ ()=>{setState({...state, displayTextColorPicker:false})} }/>
                                <SketchPicker color={ state.textColor } onChange={ onChangeTextColor } />
                            </div>
                        }
                    </div>
                    <div className="option">
                        <div className="label">정렬</div> 
                        <button className={`btn _xsm ${state.textAlign==='left'?'on':''}`} value="left" onClick={onChangeTextAlign}><i className="fas fa-align-left"></i>&nbsp;</button>
                        <button className={`btn _xsm ${state.textAlign==='center'?'on':''}`} value="center" onClick={onChangeTextAlign}><i className="fas fa-align-center"></i>&nbsp;</button>
                        <button className={`btn _xsm ${state.textAlign==='right'?'on':''}`} value="right" onClick={onChangeTextAlign}><i className="fas fa-align-right"></i>&nbsp;</button>
                    </div>
                </div>
            }
        </div>
    );
    

}

TextTool.defaultProps = {
    canvas:null,
    className:'left'
};

export default TextTool;